import { render, staticRenderFns } from "./KbRagPage.vue?vue&type=template&id=3c334243&scoped=true"
import script from "./KbRagPage.vue?vue&type=script&lang=js"
export * from "./KbRagPage.vue?vue&type=script&lang=js"
import style0 from "./KbRagPage.vue?vue&type=style&index=0&id=3c334243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c334243",
  null
  
)

export default component.exports